if (!customElements.get('fsa-hsa-savings')) {
  customElements.define('fsa-hsa-savings', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.updateDays();
      this.addEventListener('click', event => {
        const rate = event.target.closest('[data-fsa-rate-option]');
        if (rate) this.selectRate(Number(rate.dataset.fsaRateOption));
      }, options);
      this.addEventListener('submit', event => {
        const form = event.target.closest('.fsa-savings__form');
        if (form) this.addToCart(event, form);
      }, options);
      this.addEventListener('change', event => {
        const form = event.target.closest('.fsa-savings__form');
        if (form) form.querySelector('[role="alert"]').hidden = true;
      }, options);
    }

    disconnectedCallback() { this.controller?.abort(); }

    formatMoney(cents) {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: this.dataset.currency || 'USD' }).format(cents / 100);
      } catch (error) {
        return `$${(cents / 100).toFixed(2)}`;
      }
    }

    updateDays() {
      const days = this.querySelector('[data-fsa-days]');
      if (!days) return;
      const now = new Date();
      const yearEnd = new Date(now.getFullYear(), 11, 31);
      days.textContent = Math.max(0, Math.ceil((yearEnd.getTime() - now.getTime()) / 864e5));
    }

    selectRate(percent) {
      if (!Number.isFinite(percent)) return;
      const keep = 1 - percent / 100;
      this.querySelectorAll('[data-fsa-rate-option]').forEach(button => {
        button.setAttribute('aria-pressed', String(Number(button.dataset.fsaRateOption) === percent));
      });
      this.querySelectorAll('[data-fsa-rate]').forEach(rate => { rate.textContent = percent; });
      this.querySelectorAll('[data-fsa-effective]').forEach(price => {
        price.textContent = this.formatMoney(Math.round(Number(price.dataset.price) * keep));
      });
      const reference = Number(this.dataset.referencePrice);
      const effective = Math.round(reference * keep);
      this.querySelectorAll('[data-fsa-reference-effective]').forEach(price => { price.textContent = this.formatMoney(effective); });
      this.querySelectorAll('[data-fsa-reference-savings]').forEach(price => { price.textContent = this.formatMoney(reference - effective); });
    }

    async addToCart(event, form) {
      event.preventDefault();
      if (form.dataset.pending || !form.reportValidity()) return;
      const selected = form.querySelector('[name="id"]:checked:not(:disabled)') || form.querySelector('input[type="hidden"][name="id"]');
      if (!selected) return;
      const submit = form.querySelector('[type="submit"]');
      const error = form.querySelector('[role="alert"]');
      const drawer = document.querySelector('cart-drawer');
      const label = submit.textContent;
      const id = selected.value;
      form.dataset.pending = 'true';
      submit.disabled = true;
      submit.textContent = this.dataset.addingLabel;
      error.hidden = true;
      let added = false;
      try {
        drawer?.setActiveElement(submit);
        const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id, quantity: 1 }], sections: drawer?.getSectionsToRender().map(section => section.id), sections_url: window.location.pathname })
        });
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(result.description || result.message || this.dataset.errorMessage);
        added = true;
        if (typeof publish === 'function') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'fsa-hsa-savings', productVariantId: id, cartData: result });
        if (drawer && result.sections && Object.values(result.sections).every(Boolean)) {
          drawer.classList.remove('is-empty');
          drawer.renderContents(result);
        } else window.location.assign(window.routes?.cart_url || `${window.Shopify.routes.root}cart`);
      } catch (failure) {
        if (added) { window.location.assign(window.routes?.cart_url || `${window.Shopify.routes.root}cart`); return; }
        error.textContent = failure instanceof TypeError ? this.dataset.errorMessage : failure.message;
        error.hidden = false;
      } finally {
        delete form.dataset.pending;
        submit.disabled = false;
        submit.textContent = label;
      }
    }
  });
}
